<template>
    <a-modal title="工作流节点设置"
             :width="780"
             :visible="visible"
             :maskClosable="false"
             class="wf-editor-modal"
             destroyOnClose
             @ok="onOk"
             @cancel="onCancel">
        <a-form :form="form" class="form-input">
            <a-row>
                <a-col :span="24">
                    <a-form-item label="节点名称" v-bind="formItemOneLayout">
                        <a-input v-decorator="['name',{initialValue:formData.name, rules: [{ required: true, message: '请输入节点名称'}]}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="意见类型" v-bind="formItemLayout">
                        <a-select :options="commentOptions" allowClear
                                  v-decorator="['commentTypeId',{initialValue:formData.commentTypeId}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="流向类别" v-bind="formItemLayout">
                        <a-select :options="flowTypeOptions" :disabled="isFlowTypeDisable"
                                  v-decorator="['flowType',{initialValue:formData.flowType}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="发送方式" v-bind="formItemLayout">
                        <a-select :options="sendModeOptions"
                                  v-decorator="['sendMode',{initialValue:formData.sendMode}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="操作描述" v-bind="formItemLayout">
                        <a-input v-decorator="['opName',{rules: []}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="发送目标" v-bind="formItemLayout">
                        <a-select :options="objectTypeOptions" @change="onChangeObjectType"
                                  v-decorator="['objectType',{initialValue:formData.objectType}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="特性" v-bind="formItemLayout">
                        <a-select :options="specialTypeOptions" allowClear
                                  v-decorator="['specialType',{initialValue:formData.specialType}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row v-show="formVisible.sendToUser">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择用户" v-bind="formItemOneLayout">
                        <user-selector ref="sendUser" v-decorator="['sendUserIds',{initialValue:formData.sendUserIds}]" multiple style="width:100%" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row v-show="formVisible.sendToPos">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择岗位" v-bind="formItemOneLayout">
                        <pos-selector ref="sendPos" v-decorator="['sendPosIds',{initialValue:formData.sendPosIds}]" multiple style="width:100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row v-show="formVisible.sendToRole">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择角色" v-bind="formItemOneLayout">
                        <role-selector ref="sendRole" v-decorator="['sendRoleIds',{initialValue:formData.sendRoleIds}]" multiple style="width:100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row v-show="formVisible.sendToDept">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择部门" v-bind="formItemOneLayout">
                        <dept-selector ref="sendDept" v-decorator="['sendDeptIds',{initialValue:formData.sendDeptIds}]" multiple style="width:100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="目标附加参数" v-bind="formItemOneLayout">
                        <a-input v-decorator="['objectIdsParam',{initialValue:formData.objectIdsParam}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="路径参数" v-bind="formItemOneLayout">
                        <a-input v-decorator="['routeParam',{initialValue:formData.routeParam}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="默认传阅" v-bind="formItemOneLayout">
                        <user-selector ref="yueUser" v-decorator="['yueUserIds',{initialValue:formData.yueUserIds}]" multiple />
                    </a-form-item>
                </a-col>
            </a-row>
            <WFIconSelector @change="onChangeIcon" />
        </a-form>
    </a-modal>
</template>
<script>
import UserSelector from '@/components/selector/UserSelector'
import PosSelector from '@/components/selector/PosSelector'
import RoleSelector from '@/components/selector/RoleSelector'
import DeptSelector from '@/components/selector/DeptSelector'
import WFIconSelector from './WFIconSelector'
import * as WFC from './js/WFConstants'

export default {
  components: {
    UserSelector,
    PosSelector,
    RoleSelector,
    DeptSelector,
    WFIconSelector
  },
  data () {
    return {
      formItemLayout: {
        labelCol: {
          md: { span: 6 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      formItemOneLayout: {
        labelCol: {
          md: { span: 3 }
        },
        wrapperCol: {
          md: { span: 20 }
        }
      },
      value: [],
      form: this.$form.createForm(this),
      commentOptions: [],
      flowTypeOptions: WFC.FLOW_TYPE,
      isFlowTypeDisable: false,
      sendModeOptions: [
        { value: '1', label: '到具体人' },
        { value: '2', label: '目标中所有人' },
        { value: '3', label: '部门收件箱' }
      ],
      objectTypeOptions: [
        { value: '8', label: '本部门' },
        { value: '1', label: '指定人员' },
        { value: '9', label: '任何一个人员' },
        { value: '0', label: '发送到指定岗位' },
        { value: 'Z', label: '发送到指定岗位[本部门]' },
        { value: '5', label: '发送到指定岗位[本机构]' },
        { value: '3', label: '发送到指定部门' },
        { value: '4', label: '发送到指定部门[本机构]' },
        { value: '2', label: '发送到指定角色[本机构]' },
        { value: 'J', label: '发送到指定角色[所有机构]' },
        { value: 'G', label: '自定义群组' },
        { value: 'C', label: '自定义类' }
      ],
      specialTypeOptions: [
        { value: WFC.WF_ACTIVITY_SPECIAL_TYPE_CIRCLE_START, label: '分流开始' }
      ],
      formVisible: {
        sendToUser: false,
        sendToPos: false,
        sendToRole: false,
        sendToDept: false
      },
      formData: {
        name: '',
        commentTypeId: '',
        flowType: 'E',
        sendMode: '1',
        objectType: '8',
        specialType: '',
        objectIds: '',
        objectIdsParam: '',
        routeParam: '',
        yueUserIds: '',
        sendUserIds: '',
        sendPosIds: '',
        sendRoleIds: '',
        sendDeptIds: ''
      },
      wfNode: null,
      visible: false
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.visible = true
      this.onRestForm()
      this.onInit()
    },
    onRestForm () {
      this.formData = {
        name: '',
        commentTypeId: '',
        flowType: 'E',
        sendMode: '1',
        objectType: '8',
        specialType: '',
        objectIds: '',
        objectIdsParam: '',
        routeParam: '',
        yueUserIds: '',
        sendUserIds: '',
        sendPosIds: '',
        sendRoleIds: '',
        sendDeptIds: ''
      }
    },
    onInit () {
      let wfXml = this.wfNode.workflow.getWfXml()
      this.commentOptions = wfXml.getComments().map(item => {
        return {
          value: item.uuid,
          label: item.name
        }
      })
      this.onInitPage()
    },
    onInitPage () {
      this.formData.name = this.wfNode.getName()
      this.wfNode.pushWFAttributes(this.formData)

      this.onChangeObjectType(this.formData.objectType)

      if (!this.wfNode.workflow.isEditMode()) {
        // 如果是原始对象就不可以编辑
        if (this.wfNode.isSrc()) {
          this.isFlowTypeDisable = true
        }
      }
    },
    onChangeObjectType (value) {
      this.resetObjectTypeForm()
      if (value === WFC.SEND_OBJECT_TYPE_USER) {
        this.formVisible.sendToUser = true
      } else if (value === WFC.SEND_OBJECT_TYPE_POS || value === WFC.SEND_OBJECT_TYPE_LOCAL_POS || value === WFC.SEND_OBJECT_TYPE_LOCAL_DEPT_POS) {
        this.formVisible.sendToPos = true
      } else if (value === WFC.SEND_OBJECT_TYPE_ROLE || value === WFC.SEND_OBJECT_TYPE_ROLE_ALL_ORG) {
        this.formVisible.sendToRole = true
      } else if (value === WFC.SEND_OBJECT_TYPE_DEPT || value === WFC.SEND_OBJECT_TYPE_LOCAL_DEPT) {
        this.formVisible.sendToDept = true
      }
    },
    onOk () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let data = this.form.getFieldsValue()
        this.formData = Object.assign(this.formData, data)

        let objectType = this.formData.objectType
        let sendMode = this.formData.sendMode
        let flowType = this.formData.flowType

        if (objectType === WFC.SEND_OBJECT_TYPE_USER) {
          if (!this.formData.sendUserIds) {
            this.$message.error('您选择了发送至人,但还没选择任何人')
            return
          }
          this.wfNode.setWFAttributes('USER', this.$refs.sendUser.getSelected())
        } else if (objectType === WFC.SEND_OBJECT_TYPE_POS || objectType === WFC.SEND_OBJECT_TYPE_LOCAL_POS || objectType === WFC.SEND_OBJECT_TYPE_LOCAL_DEPT_POS) {
          if (!this.formData.sendPosIds) {
            this.$message.error('您选择了发送至岗位,但还没选择任何岗位')
            return
          }
          this.wfNode.setWFAttributes('POS', this.$refs.sendPos.getSelected())
        } else if (objectType === WFC.SEND_OBJECT_TYPE_ROLE || objectType === WFC.SEND_OBJECT_TYPE_ROLE_ALL_ORG) {
          if (!this.formData.sendRoleIds) {
            this.$message.error('您选择了发送至角色,但还没选择任何角色')
            return
          }
          this.wfNode.setWFAttributes('ROLE', this.$refs.sendRole.getSelected())
        } else if (objectType === WFC.SEND_OBJECT_TYPE_DEPT || objectType === WFC.SEND_OBJECT_TYPE_LOCAL_DEPT) {
          if (!this.formData.sendDeptIds) {
            this.$message.error('您选择了发送至部门,但还没有选择任何部门')
            return
          }
          this.wfNode.setWFAttributes('DEPT', this.$refs.sendDept.getSelected())
        }

        this.wfNode.setWFAttributes('YUEUser', this.$refs.yueUser.getSelected())

        // 检查新的发送模式的匹配
        if (this.formData.flowType === 'E') {
          // 一般电子送件因为只能选择一个人所以不能选择第二项
          if (sendMode === '2') {
            this.$message.error('一般电子送件的情况下，不能使用发送到目标的所有人，因为一般电子送件只对单人有效果')
            return
          }
        }

        if (sendMode === '3') {
          if (objectType === WFC.SEND_OBJECT_TYPE_LOCAL_DEPT || objectType === WFC.SEND_OBJECT_TYPE_ALL_USER) {
            this.$message.error('使用文件池方式时，不能使用以下的发送目标：\n1.本部门\n2.任何人')
            return
          }
        }

        if (sendMode === '2') {
          if (objectType === WFC.SEND_OBJECT_TYPE_ALL_USER) {
            this.$message.error('使用发送至所有人时，发送目标不能是任何人')
            return
          }
        }

        if (flowType === 'H' || flowType === 'I') {
          if (sendMode === '2') {
            this.$message.error('会签送件时使用发送到所有人不具备实际意义')
            return
          }
        }
        if (flowType === 'P') {
          if (sendMode === '3') {
            this.$message.error('纸质送件不允许使用文件池的方式')
            return
          }
        }
        if (flowType === 'T') {
          if (sendMode !== '1') {
            this.$message.error('批量送件只支持到具体人的方式，并发送件可实现你想要的效果')
            return
          }
        }

        this.wfNode.setName(this.formData.name)
        this.wfNode.fixLayout()
        this.wfNode.setWFAttributes('FORM', this.formData)
        this.wfNode.setWFAttributes('SPECIAL_TYPE', this.formData.specialType)
        this.wfNode.setWFAttributes('SEND_MODE', sendMode)
        this.wfNode.setWFAttributes('FLOW_TYPE', flowType)
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.visible = false
    },
    resetObjectTypeForm () {
      this.formVisible.sendToUser = false
      this.formVisible.sendToPos = false
      this.formVisible.sendToRole = false
      this.formVisible.sendToDept = false
    },
    onChangeIcon (path) {
      this.wfNode.setIcon(path)
      this.onOk()
    }
  }
}
</script>
<style scoped lang="less">
    .form-item-slim {
        margin-bottom: 8px
    }
</style>
<style lang="less">
    .wf-editor-modal .ant-modal-body {
        padding: 8px 0 8px 14px !important;
    }

    .wf-editor-modal .ant-form-item-label {
        line-height: 28px;
    }
</style>
